import { getNetworkData, NetworkData } from '../../locality/networkDataStorage';
import {
  NODE_KEY,
  getAgentId,
  getStoredGuidCheckingOpener
} from '../../util/storage';

export function getNodeId(): string {
  return getStoredGuidCheckingOpener(NODE_KEY);
}

export default class Node implements NetworkData {
  readonly tenantId: string;
  readonly contentId: string;
  readonly nodeId: string;
  readonly agentId: string;
  readonly clusterId?: string;
  readonly externalIp?: string;
  readonly internalIp?: string;
  readonly internalMdns?: string;

  static create(tenantId: string, contentId: string): Node {
    const nodeId = getNodeId();
    const agentId = getAgentId();
    return new Node(tenantId, contentId, nodeId, agentId);
  }

  static from(config: Node): Node {
    const {
      tenantId,
      contentId,
      nodeId,
      agentId,
      externalIp,
      internalIp,
      internalMdns
    } = config;
    return new Node(
      tenantId,
      contentId,
      nodeId,
      agentId,
      externalIp,
      internalIp,
      internalMdns
    );
  }

  constructor(
    tenantId: string,
    contentId: string,
    nodeId: string,
    agentId: string,
    externalIp?: string,
    internalIp?: string,
    internalMdns?: string
  ) {
    const networkData = getNetworkData();
    this.tenantId = tenantId;
    this.contentId = contentId;
    this.nodeId = nodeId;
    this.agentId = agentId;
    this.externalIp = externalIp || networkData.externalIp;
    this.internalIp = internalIp || networkData.internalIp;
    this.internalMdns = internalMdns || networkData.internalMdns;
  }
}
